import { renameNodeDTO, TreeNodeExpanded } from 'business/models/CustomModels';
import {
  BooleanPropertyDTO,
  CreateNewTreeNodeDTO,
  ISearchDTO,
  FragmentScreenDTO,
  PFDocProteinFormulationDTO,
  PFDocSaveProteinFormulationDTO,
  PFDocSaveResult,
  PFStateDTO,
  TreeNodeDTO,
  TreeNodeListDTO,
} from 'business/models/Models';
import React, {
  memo,
  ReactElement,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import './TreeControlHeader.scss';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { ReactComponent as FragmentScreenLogo } from 'components/main/images/TreeControl/FragmentScreen.svg';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import CustomBreadCrumbs from '../CustomBreadCrumbs/CustomBreadCrumbs';
import EViewType from 'enums/EViewType';
import ETreeNodeAccessRightNames from 'enums/ETreeNodeAccessRightNames';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import RenameComponent from 'components/commandpanel/RenameComponent/RenameComponent';
import { isAdministrator, isNullOrUndefined, showAlertSnackBar } from 'utils/Global';
import { HitsReportOptionsDialogue } from 'components/reports/HitsReportOptionsDialogue';
import { RMModal, useModalHandlers } from 'components/modal';
import TreeNodeCreator from 'components/main/tree/CreateNodeModal';
import { ECreateNodeType } from 'components/main/tree/ProjectNode';
import { useRockFetchPost } from 'utils/RockFetch';
import ScreenService from 'business/services/ScreenService';
import { getNodeLink } from '../NodesGroupView/NodesGroupView';
import ProteinFormulationService from 'business/services/ProteinFormulationService';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { TreeService } from 'business/services/TreeService';
import { TreeControlState } from 'components/explorer';
import UserAccessRight from 'components/main/userGroup/accessRight';
import { createSynchTrip } from 'components/synchrotron/utils';
import MarcoService from 'business/services/MarcoService';
import { GlobalPreferencesService } from 'business/services/GlobalPreferencesService';
import { createNewSearchNode } from 'components/searchAndFilter/utils';
import FragmentService from 'business/services/FragmentService';
import useRMLite from 'CustomHooks/useRMLite';
import { buildTree, canAddProject } from 'components/explorer/utils';
import StorageInfo from '../StorageInfo/StorageInfo';
import StorageInfoService from 'business/services/StorageInfoService';
import { STORAGE_INFO_TASK_ID } from '../StorageInfo/constants';
import { FmlxModal } from 'fmlx-common-ui';
import RMDropdown from 'components/dropdowns/RMDropdown';
import { AllowedNodeTypesForSendToMarco } from 'components/explorer/constants';
import useSetNodeRightClick, {
  useSetNodeMultiSelectRightClick,
} from 'components/rightClick/hooks/explorerHooks';
import {
  useExportPOI,
  useGenerateScreenStocksReport,
  useMarkAsNotSeen,
  useRotateCanvas,
} from 'components/Experiment/hooks';
import SynchTripReportOptions from 'components/synchrotron/synchTripReportOptions';
import { EPlateState } from 'enums/EPlatestate';
import {
  exportTextScreen,
  ExportToXMLExperimentfromExpId,
} from 'components/exports/XMLFileHelper';
import ExperimentReportDialogueWrapper from 'components/reports/ExperimentReportDialogueWrapper';
import { EReportTypes } from 'enums/EIconPanels';
import { useLicenseAuthorizeCommand } from 'CustomHooks';
import { EUserAction, ExplorerFocusArea, KeyboardKeys } from 'constants/index';
import RotateCanvasModal from 'components/modal/rotateCanvasModal';
import { isImageNowDisabled, isNewSnfDisabled } from './utils';
import { ERightClickAction } from './constants';
import { TreeControlFlags } from '../hooks';
import { getNormalizedKeyboardKey } from 'keyboardShortcuts/utils';
import { useSystemState } from 'redux/hooks/common';
import { SystemState } from 'redux/reducers/commonReducer';
import EMultiSelectionTypes from 'enums/EMultiSelectionTypes';
import ImagingSchedule from 'components/customComponents/Experiment/ImagingSchedule/ImagingSchedule';
import { useRMSelector } from 'redux/hooks';
import { selectProductEdition } from 'redux/selectors/StateSelectors';
import { EProductEditions } from 'enums/EProductEditions';
import useSystemBusyCheck from 'CustomHooks/useSystemBusyCheck';
import ExperimentService from '../../../../business/services/ExperimentService';

interface TreeControlHeaderProps {
  isProteinControl: boolean;
  isScreenControl: boolean;
  treenodes: TreeNodeListDTO;
  selectedNodes: any[];
  crumbs: any;
  createNewNode: any;
  OnBreadCrumbClickSelect: (node: TreeNodeExpanded) => void;
  newFolderType: ETreeNodeTypes;
  refreshTreeNodeAfterRename: (node: renameNodeDTO) => void;
  onRefreshTreeNodeAfterForceUnlock: (node: TreeNodeDTO) => void;
  nodeOpenHandler: any;
  cutNode: () => void;
  copyNode: () => void;
  pasteNode: () => void;
  deleteNode: () => void;
  printBarcode: () => void;
  treeControlState: TreeControlState;
  setTreeControlState: React.Dispatch<React.SetStateAction<TreeControlState>>;
  setViewType: (view: EViewType) => void;
  nodesToCopy: TreeNodeDTO[];
  openImageNowModal: () => void;
  setShowProteinVariantModal: (show: boolean) => void;
  treeControlFlags: TreeControlFlags;
  focusedArea?: ExplorerFocusArea;
}

interface ModalStates {
  showModal: boolean;
  body: ReactElement;
  heading: any;
  onOk?: () => void;
  showButtons?: boolean;
  dialogClassName?: string;
  size?: FmlxModal.Size;
  isOkOnly?: boolean;
  okButtonText?: string;
  noButtonText?: string;
  onHide?: () => void;
  titleClr?: string;
  content?: ReactElement | null;
}

const marcoModalBody = (
  <div id="tree-control-header-marco-modal-body">
    Latest inspections of each plate will be sent to MARCO Scorer. Some experiments may
    contain disputed scores from previous MARCO scoring. ROCK MAKER will still send those
    images for rescoring, but the disputed scores will be replaced with new scores and
    FORMULATRIX will have no record of the initial dispute. Are you sure you want to
    continue?
  </div>
);

export const AllowedTypesForOperation: ETreeNodeTypes[] = [
  ETreeNodeTypes.Project,
  ETreeNodeTypes.ProjectsFolder,
  ETreeNodeTypes.ScreensFolder,
  ETreeNodeTypes.ProjectFolder,
  ETreeNodeTypes.Experiment,
  ETreeNodeTypes.Protein,
  ETreeNodeTypes.Screen,
  ETreeNodeTypes.SynchrotronTripv4Folder,
  ETreeNodeTypes.SynchrotronTripv4,
  ETreeNodeTypes.Seed,
  ETreeNodeTypes.FragmentScreen,
  ETreeNodeTypes.SearchAnalysis,
  ETreeNodeTypes.SearchesFolder,
];

const AllowedRootNodes: ETreeNodeTypes[] = [
  ETreeNodeTypes.Projects,
  ETreeNodeTypes.Screens,
  ETreeNodeTypes.Searches,
  ETreeNodeTypes.CrystalTrackv4,
];

const AllowedTypesForBarcodeOperation: ETreeNodeTypes[] = [
  ETreeNodeTypes.Project,
  ETreeNodeTypes.ProjectsFolder,
  ETreeNodeTypes.ScreensFolder,
  ETreeNodeTypes.ProjectFolder,
  ETreeNodeTypes.Experiment,
];

const AllowedTypesForHitReportOperation: ETreeNodeTypes[] = [
  ETreeNodeTypes.Project,
  ETreeNodeTypes.ProjectsFolder,
  ETreeNodeTypes.ScreensFolder,
  ETreeNodeTypes.ProjectFolder,
  ETreeNodeTypes.Experiment,
];

const SynchrotronTypes: ETreeNodeTypes[] = [
  ETreeNodeTypes.SynchrotronTripv4,
  ETreeNodeTypes.SynchrotronTripv4Folder,
];

const isAnalyzeAllowedMultiSelect = (nodes: TreeNodeDTO[]) => {
  const disallowedTypes = new Set<ETreeNodeTypes>([
    ETreeNodeTypes.SynchrotronTripv4,
    ETreeNodeTypes.SynchrotronTripv4Folder,
    ETreeNodeTypes.Screen,
    ETreeNodeTypes.Screens,
    ETreeNodeTypes.Searches,
    ETreeNodeTypes.SearchesFolder,
    ETreeNodeTypes.SearchAnalysis,
  ]);

  return !nodes.some((node) => disallowedTypes.has(node.type as ETreeNodeTypes));
};
/**
 * which types of nodes are allowed in Projects Folder at root level
 */

const marcoService = new MarcoService();
const headerIconsColor = '#313131';
const treeService = new TreeService();
const currentSelectedFirstNode = { node: null };

const modalDefaultState = {
  heading: '',
  content: null,
  show: false,
  showButtons: false,
  isOkOnly: false,
  okButtonText: '',
  noButtonText: '',
  dialogClassName: '',
  titleClr: '',
  onHide: () => {},
  size: FmlxModal.Size.SMALL,
};

function TreeControlHeader({
  isProteinControl,
  isScreenControl,
  treenodes,
  selectedNodes,
  crumbs,
  createNewNode,
  OnBreadCrumbClickSelect,
  newFolderType,
  refreshTreeNodeAfterRename,
  onRefreshTreeNodeAfterForceUnlock,
  nodeOpenHandler,
  cutNode,
  copyNode,
  pasteNode,
  deleteNode,
  printBarcode,
  treeControlState,
  setTreeControlState,
  openImageNowModal,
  setShowProteinVariantModal,
  treeControlFlags,
  focusedArea,
}: TreeControlHeaderProps) {
  const [rockFetchPost] = useRockFetchPost();
  const { showModal: showBulkScheduleModal, hideModal: hideBulkScheduleModal } =
    useModalHandlers();
  const [showRenameModal, setShowRenameModal] = useState<boolean>(false);
  const [sampleSearches, setSampleSearches] = useState([]);
  const [projectsSubmenu, setProjectsSubmenu] = useState([]);
  const [showHitReportOptions, setShowHitReportOptions] = useState<boolean>(false);
  const [modalStates, setModalStates] = useState<ModalStates>({
    showModal: false,
    body: <div id="tree-control-header-props">Please Wait</div>,
    heading: 'ROCK MAKER',
    onOk: null,
    showButtons: true,
    dialogClassName: '',
    size: FmlxModal.Size.MEDIUM,
  });
  const [createNodeType, setCreateNodeType] = useState(ECreateNodeType.None);
  const [isBarcodeProperty, setIsBarcodeProperty] = useState<boolean>();
  const [isMarcoScoringEnabled, setIsMarcoScoringEnabled] = useState(true);
  const [modalDetails, setModalDetails] = useState(modalDefaultState);
  const [showModal, setShowModal] = useState(false);
  const rmLite = useRMLite();
  const { checkSystemBusy } = useSystemBusyCheck();
  currentSelectedFirstNode.node = selectedNodes[0];
  const analyzeSnfQueryString = (treeNodeIds?: number[]) => {
    const ids = (treeNodeIds ?? []).filter((id) => Number.isFinite(id));
    if (!ids.length) {
      return '';
    }
    return `?treeNodeIds=${encodeURIComponent(ids.join(','))}`;
  };
  const [showNoHitError, setShowNoHitError] = useState(false);
  const [reportType, setReportType] = useState<string>('');
  const [maxHitsReportDropNumber, setMaxHitsReportDropNumber] = useState<number>(0);
  const bulkScheduleSaveHandlerRef = useRef<(() => Promise<void>) | null>(null);
  const setNodeRightClick = useSetNodeRightClick();
  const setMultiNodesRightClick = useSetNodeMultiSelectRightClick();
  const exportPOI = useExportPOI();
  const markAskNotSeen = useMarkAsNotSeen();
  const generateScreenStocksReport = useGenerateScreenStocksReport();
  const rotateCanvas = useRotateCanvas();
  const licenseAuthCommand = useLicenseAuthorizeCommand();
  const {
    isAnySelectedNodeLocked,
    isEditAllowed,
    canModifyNode,
    isControlsDisabled,
    isAddNotAllowed,
    copyDisabled,
    pasteDisabled,
    cutDisabled,
  } = treeControlFlags;
  const [isAddingNode, setIsAddingNode] = useState(false);
  const systemState = useSystemState();
  const isSystemBusy = systemState !== SystemState.IDLE;
  const productEdition = useRMSelector(selectProductEdition);
  const isPlatePreviewEdition = productEdition === EProductEditions.PlateViewer;

  const isQuickAccessNodeSelected =
    treeControlState?.selectedExplorerNode?.type === ETreeNodeTypes.QuickAccess;

  const qaNodes = treeControlState?.treenodes[0]?.children?.map(
    (item) => item?.extra?.originalId,
  );
  const {
    doAllSelectedNodesExistInQuickAccess,
    doAllSelectedNodesNotExistInQuickAccess,
  } = treeControlState.selectedNodes.reduce(
    (acc, node: TreeNodeDTO) => {
      const nodeCondition = qaNodes?.includes(node?.extra?.originalId);

      acc.doAllSelectedNodesExistInQuickAccess =
        acc.doAllSelectedNodesExistInQuickAccess && nodeCondition;
      acc.doAllSelectedNodesNotExistInQuickAccess =
        acc.doAllSelectedNodesNotExistInQuickAccess && !nodeCondition;

      return acc;
    },
    {
      doAllSelectedNodesExistInQuickAccess: true,
      doAllSelectedNodesNotExistInQuickAccess: true,
    },
  );

  const isRootNodeAccessControl = isRootNodeAccessControlEnabled();
  const isBarcodeButtonDisabled = isBarcodeDisabled();
  const isHitReportButtonDisabled = isHitReportDisabled();

  const printBarcodeDisabled =
    isAnySelectedNodeLocked ||
    isControlsDisabled ||
    isNullOrUndefined(selectedNodes[0]?.extra?.id) ||
    isBarcodeButtonDisabled ||
    !isBarcodeProperty;

  const hitsReportDisabled =
    rmLite ||
    isControlsDisabled ||
    !selectedNodes[0]?.id ||
    selectedNodes[0]?.locked ||
    isHitReportButtonDisabled ||
    isQuickAccessNodeSelected;

  useEffect(() => {
    const gpService = new GlobalPreferencesService();
    const fetchBarcodePropertyData = async () => {
      const result: any = await gpService.getUserProperty(
        'ExperimentPlate.AllowBarcodePrintingFromTree',
      );
      setIsBarcodeProperty(result.value);
      const analyzeMenuNodesData = await treeService.getAnalyzeTreeNodes();
      await getSampleSearches(analyzeMenuNodesData.searchesNodes);
      await getProjectsSubMenu(analyzeMenuNodesData.projectsNodes);
    };

    const getMarcoAutoScoreEnabledStatus = async () => {
      const property = (await gpService.getProperty(
        'Scores.MARCOAutoScoring.Enabled',
      )) as BooleanPropertyDTO;
      setIsMarcoScoringEnabled(property.value);
    };
    fetchBarcodePropertyData();
    getMarcoAutoScoreEnabledStatus();

    const handleKeyDown = (e: KeyboardEvent) => {
      if (rmLite || isQuickAccessNodeSelected || focusedArea === ExplorerFocusArea.None) {
        return;
      }
      const ctrlKey = e.ctrlKey || e.metaKey;

      if (ctrlKey && getNormalizedKeyboardKey(e) === KeyboardKeys.c && !copyDisabled) {
        e.preventDefault();
        copyNode();
      }

      if (ctrlKey && getNormalizedKeyboardKey(e) === KeyboardKeys.v && !pasteDisabled) {
        e.preventDefault();
        pasteNode();
      }

      if (ctrlKey && getNormalizedKeyboardKey(e) === KeyboardKeys.X && !cutDisabled) {
        e.preventDefault();
        cutNode();
      }

      if (
        e.key === KeyboardKeys.F2 &&
        !showRenameModal &&
        !actionMap[ERightClickAction.Rename].isDisabled
      ) {
        e.preventDefault();
        setShowRenameModal(true);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [
    isControlsDisabled,
    isAnySelectedNodeLocked,
    copyNode,
    pasteNode,
    cutNode,
    showRenameModal,
  ]);

  const pinToQuickAccess = async () => {
    if (
      treeControlState.selectedNodes.some(
        (node) => !folderNodeTypes.includes(node.type as ETreeNodeTypes),
      )
    ) {
      showAlertSnackBar(
        EAlertType.WARNING,
        ESnackBarPosition.TOP,
        'Only container nodes can be pinned to quick access.',
      );
    } else if (
      treeControlState.selectedNodes.some((node) =>
        treeControlState.treenodes.find((treeNode) => treeNode.id == node.id),
      )
    ) {
      showAlertSnackBar(
        EAlertType.WARNING,
        ESnackBarPosition.TOP,
        'Top container nodes can not be pinned to quick access.',
      );
    } else {
      const result = await treeService.pinToQuickAccess(
        treeControlState.selectedNodes.map((treeNode) => treeNode.extra.originalId),
      );

      if (result == 1) {
        showAlertSnackBar(
          EAlertType.SUCCESS,
          ESnackBarPosition.TOP,
          'Selected nodes has been pinned to quick access.',
        );

        if (treeControlState?.treenodes[0]?.children) {
          const newQaNodes = treeControlState.selectedNodes.map((treeNode) => {
            const quickAccessMeta = {
              originalId: treeNode.id,
            };
            return {
              ...treeNode,
              id: treeNode.id * 100000,
              extra: {
                quickAccessMeta: { ...quickAccessMeta },
                originalId: treeNode.id,
              },
            };
          });

          setTreeControlState((prev: TreeControlState) => ({
            ...prev,
            treenodes: [
              {
                ...prev.treenodes[0],
                children: [...prev.treenodes[0].children, ...newQaNodes],
              },
              ...prev.treenodes.slice(1),
            ],
          }));
        }
      } else {
        showAlertSnackBar(
          EAlertType.WARNING,
          ESnackBarPosition.TOP,
          'Selected nodes already pinned in quick access.',
        );
      }
    }
  };

  const unPinFromQuickAccess = async () => {
    const result = await treeService.unpinFromQuickAccess(
      treeControlState.selectedNodes.map((treeNode) => treeNode.extra.originalId),
    );
    if (result == 1) {
      setTreeControlState((prev) => {
        const { selectedNodes, treenodes, viewNodes } = prev;

        const updatedTreenodes = treenodes.map((treenode, index) =>
          index === 0
            ? {
                ...treenode,
                children: treenode.children.filter(
                  (node) =>
                    !selectedNodes.some(
                      (selectedNode) =>
                        selectedNode.extra.originalId === node?.extra?.originalId,
                    ),
                ),
              }
            : treenode,
        );

        const updatedViewNodes = viewNodes.filter(
          (node) =>
            !selectedNodes.some(
              (selectedNode) =>
                selectedNode.extra.originalId ===
                node?.extra?.quickAccessMeta?.originalId,
            ),
        );

        return {
          ...prev,
          treenodes: updatedTreenodes,
          viewNodes: updatedViewNodes,
          // clear selected node when the opened node is quick access
          // since the items will be removed from node view
          selectedNodes: isQuickAccessNodeSelected ? [] : selectedNodes,
        };
      });
      showAlertSnackBar(
        EAlertType.SUCCESS,
        ESnackBarPosition.TOP,
        'Selected nodes has been removed from quick access.',
      );
    } else {
      showAlertSnackBar(
        EAlertType.WARNING,
        ESnackBarPosition.TOP,
        'Selected nodes does not exist in quick access.',
      );
    }
  };

  const folderNodeTypes = [
    ETreeNodeTypes.Project,
    ETreeNodeTypes.ProjectFolder,
    ETreeNodeTypes.ProjectsFolder,
    ETreeNodeTypes.Projects,
    ETreeNodeTypes.Screens,
    ETreeNodeTypes.ScreensFolder,
    ETreeNodeTypes.QuickAccess,
  ];

  const forceUnlockBody = useMemo(
    () => (
      <div id="tree-control-header-force-unlock-body-selected-node">{`Are you sure you want to unlock '${selectedNodes[0]?.name}' by force?`}</div>
    ),
    [selectedNodes],
  );

  /** Adding call back to this method as it is used in explorer right click,
   if we dont memoize it, then it will cause infinite re-rendering
   due to new refernece each time. Handle with caution */
  const openNode = useCallback(() => {
    if (selectedNodes.length) {
      const link = getNodeLink(selectedNodes[0]);
      nodeOpenHandler(
        link,
        selectedNodes[0],
        `node${selectedNodes[0]?.id}`,
        true,
        `inputNameode${selectedNodes[0]?.id}`,
        2, //2 is for double click
      );
    }
  }, [selectedNodes, nodeOpenHandler]);

  const sendTreeNodeToMarco = async () => {
    // Hide modal while waiting
    setModalStates({ ...modalStates, showModal: false });

    try {
      const numberOfDropsToBeScored = await marcoService.sendToMarcoFromExplorer(
        selectedNodes[0]?.id,
      );

      if (numberOfDropsToBeScored === 0) {
        //None of the drops have a visible light path image
        setModalStates({
          ...modalStates,
          showModal: true,
          isOkOnly: true,
          heading: 'ROCK MAKER',
          body: (
            <div id="tree-control-header-number-of-drops-to-be-scored">
              No visible light path image found in current inspection. Auto scoring
              currently only supports visible lightpath images.
            </div>
          ),
          showButtons: true,
          okButtonText: 'OK',
          onOk() {
            hideModal(false);
          },
        });
      } else {
        // Success case
        showAlertSnackBar(
          EAlertType.SUCCESS,
          ESnackBarPosition.TOP,
          'Current inspection has been queued to be scored by Sherlock/MARCO. Scores will appear soon.',
        );
      }
    } catch (error) {
      console.error(error);
      showAlertSnackBar(
        EAlertType.ERROR,
        ESnackBarPosition.TOP,
        'Failed to send data to Marco.',
      );
    }
  };

  const sendToMarco = () => {
    setModalStates({
      ...modalStates,
      showModal: true,
      heading: 'Marco Scorer',
      body: marcoModalBody,
      onOk: sendTreeNodeToMarco,
      showButtons: true,
    });
  };
  const bulkSendToAutoScore = useCallback(async () => {
    let string = '';
    const plateIds = [];
    treeControlState.selectedNodes.forEach((node) => {
      const extra = node?.extra;
      if (
        extra?.plateState !== EPlateState.Imaged &&
        extra?.plateState !== EPlateState.CrystalHarvested
      ) {
        string += node.name + ',';
      } else {
        extra.plates.forEach((plate) => {
          plateIds.push(plate.id);
        });
      }
    });
    if (string) {
      string = string.slice(0, -1);
      showAlertSnackBar(
        EAlertType.WARNING,
        ESnackBarPosition.TOP,
        'The following experiments cannot be scored: ' + string,
      );
    }
    if (plateIds.length > 0) {
      const numberOfDropsToBeScored = await marcoService.sendAllPlatesToScore(plateIds);
      if (numberOfDropsToBeScored === 0) {
        setModalStates({
          ...modalStates,
          showModal: true,
          isOkOnly: true,
          heading: 'ROCK MAKER',
          body: <div>No visible light path image found for selected experiments</div>,
          showButtons: true,
          okButtonText: 'OK',
          onOk() {
            hideModal(false);
          },
        });
      } else {
        setModalStates({
          ...modalStates,
          showModal: true,
          isOkOnly: true,
          heading: 'ROCK MAKER',
          body: (
            <div>
              {numberOfDropsToBeScored} drops have been queued to be scored. Scores will
              appear soon.
            </div>
          ),
          showButtons: true,
          okButtonText: 'OK',
          onOk() {
            hideModal(false);
          },
        });
      }
    }
  }, [treeControlState.selectedNodes]);

  const forceUnlockNode = useCallback(async () => {
    setModalStates({
      ...modalStates,
      showModal: false,
      showButtons: true,
    });
    const treeService = new TreeService();
    await treeService.unlockNode(selectedNodes[0]?.id);
    onRefreshTreeNodeAfterForceUnlock(selectedNodes[0]);
  }, [selectedNodes]);
  const forceUnlock = () => {
    setModalStates({
      ...modalStates,
      showModal: true,
      heading: 'ROCK MAKER',
      body: forceUnlockBody,
      onOk: forceUnlockNode,
      showButtons: true,
      size: FmlxModal.Size.MEDIUM,
    });
  };

  const createScreenExperiment = useCallback(async () => {
    const body = {
      parentTreeNodeId: treeControlState.selectedExplorerNode?.id,
    };
    const newExp = await rockFetchPost('/api/experiment/createscreenexperiment', body);
    if (newExp === null) {
      return null;
    }
    await createNewNode(newExp, [], treeControlState.selectedExplorerNode?.id);

    window.open(`/exp/${newExp.extra.id}/info`, `/exp/${newExp.extra.id}`);
    return newExp;
  }, [treeControlState.selectedExplorerNode, createNewNode]);

  const createFragmentScreen = useCallback(async () => {
    const createFragmentScreen: FragmentScreenDTO = new FragmentScreenDTO();
    createFragmentScreen.treeNodeID = treeControlState.selectedExplorerNode?.id;
    createFragmentScreen.parentId = treeControlState.selectedExplorerNode?.id;

    const fragmentService = new FragmentService();
    const fragmentScreen: any = await fragmentService.CreateFragmentScreen(
      createFragmentScreen,
    );

    if (fragmentScreen === null) {
      return null;
    }
    fragmentScreen.extra = fragmentScreen.id;
    await createNewNode(fragmentScreen, [], treeControlState.selectedExplorerNode?.id);

    window.open(`/fragment/${fragmentScreen.id}`);
    return fragmentScreen;
  }, [treeControlState.selectedExplorerNode, createNewNode]);

  const createNewProtein = useCallback(async () => {
    const saveData: PFDocSaveProteinFormulationDTO = new PFDocSaveProteinFormulationDTO();
    saveData.proteinFormulation = new PFDocProteinFormulationDTO();
    saveData.proteinFormulation.pfName = '';
    saveData.proteinFormulation.datePrepared = new Date();
    saveData.proteinFormulation.pfState = PFStateDTO.New;
    saveData.deletedPFIngs = [];
    saveData.deletedStIngs = [];
    saveData.parentNodeId = treeControlState.selectedExplorerNode?.id;

    const res: PFDocSaveResult =
      await new ProteinFormulationService().saveProteinFormulation(saveData);
    if (!res?.data) {
      return null;
    }
    const newNode: CreateNewTreeNodeDTO = new CreateNewTreeNodeDTO();
    newNode.id = res.data.treeNodeId;
    newNode.name = res.data.pfName;
    newNode.parentId = treeControlState.selectedExplorerNode?.id;
    newNode.type = ETreeNodeTypes.Protein;
    await createNewNode(newNode, [], treeControlState.selectedExplorerNode?.id);
    window.open(`/protein/${res.data.treeNodeId}`, `/protein/${res.data.treeNodeId}`);
  }, [treeControlState.selectedExplorerNode, createNewNode]);

  const createNewScreen = useCallback(async () => {
    const screenService = new ScreenService();
    const treeNodeDTO: TreeNodeDTO = await screenService.createScreen(
      treeControlState.selectedExplorerNode?.id,
    );
    if (treeNodeDTO === null) {
      return null;
    }
    await createNewNode(treeNodeDTO, [], treeControlState.selectedExplorerNode?.id);
    window.open(
      `/screen/${treeNodeDTO.extra.id}/info`,
      `/screen/${treeNodeDTO.extra.id}`,
    );
    return treeNodeDTO;
  }, [treeControlState.selectedExplorerNode, createNewNode]);

  const createNewSynchTrip = useCallback(async () => {
    const { newSynchTrip } = await createSynchTrip(
      treeControlState.selectedExplorerNode?.id,
    );
    if (newSynchTrip === null) {
      return null;
    }
    await createNewNode(newSynchTrip, [], treeControlState.selectedExplorerNode?.id);
    window.open(
      `/synchrotrontrip/${newSynchTrip.id}`,
      `/synchrotrontrip/${newSynchTrip.id}`,
    );
  }, [treeControlState.selectedExplorerNode, createNewNode]);

  //Search n Filter item
  const createNewSearchItem = useCallback(
    async (isAnalyzeItem) => {
      const { node, id: searchId }: ISearchDTO = await createNewSearchNode(
        treeControlState.selectedExplorerNode?.id,
        isAnalyzeItem
          ? currentSelectedFirstNode?.node?.id
          : treeControlState.selectedExplorerNode?.id,
      );
      const newNode: CreateNewTreeNodeDTO = new CreateNewTreeNodeDTO();
      newNode.id = node.id;
      newNode.name = node.name;
      newNode.parentId = treeControlState.selectedExplorerNode?.id;
      newNode.type = ETreeNodeTypes.SearchAnalysis;
      await createNewNode(newNode, [], treeControlState.selectedExplorerNode?.id);
      window.open(`/snf/${searchId}`);
    },
    [treeControlState.selectedExplorerNode, createNewNode],
  );

  const onAddItem = useCallback(
    async (type, isAnalyzeItem = false) => {
      setIsAddingNode(true);
      try {
        switch (type) {
          case ETreeNodeTypes.Experiment:
            await createScreenExperiment();
            break;
          case ETreeNodeTypes.Protein:
            await createNewProtein();
            break;
          case ETreeNodeTypes.Screen:
            await createNewScreen();
            break;
          case ETreeNodeTypes.CrystalTrackv4:
            await createNewSynchTrip();
            break;
          case ETreeNodeTypes.SearchAnalysis:
            await createNewSearchItem(isAnalyzeItem);
            break;
          case ETreeNodeTypes.FragmentScreen:
            await createFragmentScreen();
            break;
        }
      } finally {
        setIsAddingNode(false);
      }
    },
    [treeControlState.selectedExplorerNode, createNewNode],
  );

  const handleStorageInfoClick = useCallback(() => {
    const selectedNodesIds = [];
    treeControlState.selectedNodes.forEach((stn) => selectedNodesIds.push(stn.id));

    setShowModal(true);
    setModalDetails({
      show: true,
      heading: 'Storage Information',
      content: <StorageInfo selectedNodesIds={selectedNodesIds} />,
      showButtons: false,
      isOkOnly: false,
      okButtonText: 'Save',
      noButtonText: 'Discard',
      dialogClassName: 'min-w-[65%] w-[65%]',
      titleClr: '#1B1B1B',
      onHide: () => {
        const storageInfoService: StorageInfoService = new StorageInfoService();
        storageInfoService.stopStorageInfoTask(STORAGE_INFO_TASK_ID);
        setShowModal(false);
      },
      size: FmlxModal.Size.QUADRUPLE_EXTRA_LARGE,
    });
  }, [treeControlState.selectedNodes]);

  /** Adding call back to this method as it is used in explorer right click,
   if we dont memoize it, then it will cause infinite re-rendering
   due to new refernece each time. Handle with caution */
  const onNewFolder = useCallback(() => {
    if (treeControlState.selectedExplorerNode.type === ETreeNodeTypes.CrystalTrackv4) {
      setCreateNodeType(ECreateNodeType.SynchrotronTripv4Folder);
    } else if (treeControlState.selectedExplorerNode.type === ETreeNodeTypes.Searches) {
      setCreateNodeType(ECreateNodeType.SearchesFolder);
    } else {
      setCreateNodeType(ECreateNodeType.ProjectFolder);
    }
  }, [treeControlState.selectedExplorerNode]);

  const AddList = useMemo(
    () => [
      {
        Icon: <RMSvgIcon name="Project" fill="rgba(49, 49, 49, 1)" />,
        label: 'Project',

        onClick: () => {
          setCreateNodeType(ECreateNodeType.Project);
        },
        isDisabled:
          rmLite || canAddProject(treeControlState.selectedExplorerNode) || isAddingNode,
      },

      {
        Icon: <RMSvgIcon name="Folder" fill="rgba(49, 49, 49, 1)" />,
        label: 'Folder',

        onClick: onNewFolder,
        isDisabled:
          rmLite ||
          treeControlState.selectedExplorerNode?.accessRightName !==
            ETreeNodeAccessRightNames.Modify,
      },
      {
        Icon: <RMSvgIcon name="Experiment" fill="rgba(49, 49, 49, 1)" />,
        label: 'Experiment',

        onClick: () => onAddItem(ETreeNodeTypes.Experiment),

        isDisabled:
          rmLite ||
          treeControlState.selectedExplorerNode?.accessRightName !==
            ETreeNodeAccessRightNames.Modify ||
          isAddNotAllowed ||
          isAddingNode,
      },

      {
        Icon: <RMSvgIcon name="Screen" fill="rgba(49, 49, 49, 1)" />,
        label: 'Screens',
        onClick: () => onAddItem(ETreeNodeTypes.Screen),
        isDisabled:
          rmLite ||
          treeControlState.selectedExplorerNode?.accessRightName !==
            ETreeNodeAccessRightNames.Modify ||
          (isAddNotAllowed &&
            treeControlState.selectedExplorerNode?.type !== ETreeNodeTypes.Screens &&
            treeControlState.selectedExplorerNode?.type !==
              ETreeNodeTypes.ScreensFolder) ||
          isAddingNode,
      },

      {
        Icon: <RMSvgIcon name="Protein" fill="rgba(49, 49, 49, 1)" />,
        label: 'Protein',
        onClick: () => onAddItem(ETreeNodeTypes.Protein),
        isDisabled:
          rmLite ||
          treeControlState.selectedExplorerNode?.accessRightName !==
            ETreeNodeAccessRightNames.Modify ||
          isAddNotAllowed ||
          isAddingNode,
      },
      {
        Icon: <FragmentScreenLogo color={'rgba(49, 49, 49, 1)'}></FragmentScreenLogo>,
        label: 'Fragment Screen',
        onClick: () => {
          onAddItem(ETreeNodeTypes.FragmentScreen);
        },
        isDisabled:
          rmLite ||
          isAddNotAllowed ||
          treeControlState.selectedExplorerNode?.accessRightName !==
            ETreeNodeAccessRightNames.Modify ||
          isAddingNode,
      },
      {
        Icon: <RMSvgIcon name="SynchrotronTrip" fill="rgba(49, 49, 49, 1)" />,
        label: 'Synchrotron Trip',
        onClick: () => onAddItem(ETreeNodeTypes.CrystalTrackv4),
        isDisabled:
          (treeControlState.selectedExplorerNode?.type !==
            ETreeNodeTypes.CrystalTrackv4 &&
            treeControlState.selectedExplorerNode?.type !==
              ETreeNodeTypes.SynchrotronTripv4Folder) ||
          isAddingNode,
      },
      {
        Icon: <RMSvgIcon name="SearchAndFilterIcon" fill="rgba(49, 49, 49, 1)" />,
        label: 'Search And Filter',
        onClick: () => onAddItem(ETreeNodeTypes.SearchAnalysis),
        isDisabled:
          isNewSnfDisabled(
            treeControlState.selectedExplorerNode,
            isPlatePreviewEdition,
          ) || isAddingNode,
      },
    ],
    [treeControlState.selectedExplorerNode, isAddNotAllowed, createNewNode, isAddingNode],
  );

  const getSampleSearches = async (nodes) => {
    const nodesToShow = await creatAnalyzeData(nodes);
    setSampleSearches(nodesToShow);
  };

  const creatAnalyzeData = async (nodes) => {
    const getSearchesChildren = nodes?.map(async (item) => {
      const icon = (
        <RMSvgIcon
          name={`${
            item.type === ETreeNodeTypes.SearchesFolder ||
            item.type === ETreeNodeTypes.ProjectsFolder ||
            item.type === ETreeNodeTypes.ProjectFolder
              ? 'Folder'
              : 'SearchAndFilterIcon'
          }`}
        />
      );

      return {
        ...item,
        label: item.name,
        onClick: () => onClickAnalyzeSnfNode(item),
        icon: icon,
        submenuItems:
          item.submenuItems && item.submenuItems.length
            ? await creatAnalyzeData(item.submenuItems)
            : [],
      };
    });

    return await Promise.all(getSearchesChildren);
  };

  const getProjectsSubMenu = async (nodeList) => {
    const rootProjectNode = await treeService.getTreeNodeByType(ETreeNodeTypes.Projects);
    const projectNodes = await creatAnalyzeData(nodeList);
    const nodes = projectNodes
      .sort((a, b) => (a.parentId || 0) - (b.parentId || 0))
      .filter((item, index, self) => index === self.findIndex((i) => i.id === item.id));
    const tree = buildTree(nodes);
    const projectsSubmenu = tree?.find(
      (nod) => nod.id === rootProjectNode[0].id,
    )?.submenuItems;
    setProjectsSubmenu(projectsSubmenu);
  };

  const onClickAnalyzeSnfNode = (item) => {
    if (item.type !== ETreeNodeTypes.SearchAnalysis) {
      return;
    }

    const selectedTreeNodeIds =
      selectedNodes?.length > 0 ? selectedNodes.map((node) => node.id) : [];

    window.open(
      `/snf/${item.extra?.id}${analyzeSnfQueryString(selectedTreeNodeIds)}`,
      `/snf/${item.extra?.id}`,
    );
  };

  const onClickHitReportButton = useCallback(async () => {
    const nodeIds = selectedNodes.map((item) => item.id);
    const expService = new ExperimentService();
    const maxDrop = await expService.getMaxDropNumberByNodeIds(nodeIds);
    if (maxDrop === 0) {
      setShowNoHitError(true);
    } else {
      setMaxHitsReportDropNumber(maxDrop);
      setShowHitReportOptions(true);
    }
  }, [selectedNodes, setShowHitReportOptions, setShowNoHitError]);

  const analyzeOptionCreateSearchAndFilterLabel = 'Create New Search and Filter';

  /** Adding call back/useMemo to this method as it is used in explorer right click,
   if we dont memoize it, then it will cause infinite re-rendering
   due to new refernece each time. Handle with caution */
  const AnalyzeOptions = useMemo(
    () => [
      {
        label: analyzeOptionCreateSearchAndFilterLabel,
        onClick: () => onAddItem(ETreeNodeTypes.SearchAnalysis, true),
        isDisabled:
          treeControlState.selectedNodes.length > 1 ||
          isNewSnfDisabled(treeControlState.selectedNodes[0], isPlatePreviewEdition),
      },
      {
        label: 'Searches',
        submenuItems: sampleSearches,
        depth: 1,
      },
      {
        label: 'Projects',
        submenuItems: projectsSubmenu,
        depth: 1,
      },
    ],
    [
      sampleSearches,
      projectsSubmenu,
      onAddItem,
      treeControlState.selectedExplorerNode,
      treeControlState.selectedNodes,
    ],
  );

  const ExtraOptions = [
    {
      icon: <RMSvgIcon name="AccessRight" fill="rgba(49, 49, 49, 1)" />,
      label: 'Access Right',

      onClick: () => {
        setModalStates({
          ...modalStates,
          heading: (
            <div
              id="tree-control-header-selected-nodes"
              className="text-fmlxOrange"
            >{`Manage Access Rights - ${selectedNodes[0]?.name}`}</div>
          ),
          body: (
            <UserAccessRight
              treeNodeId={selectedNodes[0]?.id}
              treeNodeType={selectedNodes[0]?.type}
              nodeTitle={selectedNodes[0]?.name}
              closeModal={() => setModalStates({ ...modalStates, showModal: false })}
            />
          ),
          showModal: true,
          showButtons: false,
          dialogClassName: 'tree-node-access-right',
          size: FmlxModal.Size.LARGE,
        });
      },
      isDisabled:
        rmLite ||
        !isAdministrator() ||
        isAnySelectedNodeLocked ||
        treeControlState.selectedNodes.length !== 1,
    },

    {
      icon: <RMSvgIcon name="Marco" fill="rgba(49, 49, 49, 1)" />,
      label: 'Send to Autoscore',
      onClick: licenseAuthCommand(() => {
        sendToMarco();
      }, EUserAction.SendToMarco),
      titleTip: 'Send to Autoscore',
      isDisabled:
        rmLite ||
        (!AllowedNodeTypesForSendToMarco.includes(selectedNodes[0]?.type) &&
          selectedNodes[0]?.extra?.state !== 'Imaged' &&
          selectedNodes[0]?.extra?.state !== 'CrystalHarvested' &&
          selectedNodes[0]?.extra?.state !== 'Hits') ||
        isAnySelectedNodeLocked ||
        treeControlState.selectedNodes.length !== 1 ||
        !isMarcoScoringEnabled ||
        !isRootNodeAccessControl ||
        SynchrotronTypes.includes(selectedNodes[0]?.type),
    },

    {
      icon: <RMSvgIcon name="Analyze" fill="rgba(49, 49, 49, 1)" />,
      label: 'Analyze',
      submenuItems: AnalyzeOptions,
      onClick: () => {},
      isDisabled:
        rmLite ||
        !isRootNodeAccessControl ||
        SynchrotronTypes.includes(selectedNodes[0]?.type),
    },

    {
      icon: <RMSvgIcon name="Unlock" fill="rgba(49, 49, 49, 1)" />,
      label: 'Force Unlock',

      onClick: forceUnlock,
      isDisabled:
        treeControlState.selectedNodes.length !== 1 ||
        !isAnySelectedNodeLocked ||
        !isRootNodeAccessControl,
    },

    {
      icon: <RMSvgIcon name="Info" fill="rgba(49, 49, 49, 1)" />,
      label: 'Storage Info',

      onClick: () => {
        handleStorageInfoClick();
      },
      isDisabled: false,
      titleTip: 'Storage Information',
    },
  ];

  const headerButtons: any[] = [
    {
      title: 'OPEN',
      isDisabled:
        isAnySelectedNodeLocked ||
        treeControlState.selectedNodes.length !== 1 ||
        treeControlState.selectedNodes[0] === treeControlState.selectedExplorerNode,
      contentContainerClass: 'tree-control-open-button',
      titleClass: 'tree-control-open-button-title',
      onClick: openNode,
    },
    {
      Icon: <RMSvgIcon name="Cut" width="20px" height="20px" fill={headerIconsColor} />,
      titleTip: 'Cut',
      onClick: cutNode,
      isDisabled: cutDisabled || isQuickAccessNodeSelected,
      contentContainerClass: 'tree-control-action-button',
    },

    {
      Icon: <RMSvgIcon name="Copy" width="20px" height="20px" fill={headerIconsColor} />,
      titleTip: 'Copy',
      onClick: copyNode,
      isDisabled: copyDisabled || isQuickAccessNodeSelected,
      contentContainerClass: 'tree-control-action-button',
    },

    {
      Icon: <RMSvgIcon name="Paste" width="20px" height="20px" fill={headerIconsColor} />,
      titleTip: 'Paste',
      onClick: pasteNode,
      isDisabled: pasteDisabled || isQuickAccessNodeSelected,
      contentContainerClass: 'tree-control-action-button',
    },

    {
      Icon: <RMSvgIcon name="Edit" width="20px" height="20px" fill={headerIconsColor} />,
      titleTip: 'Edit',
      onClick: () => {
        setShowRenameModal(true);
      },
      isDisabled:
        !isEditAllowed ||
        !canModifyNode ||
        selectedNodes.length !== 1 ||
        (isControlsDisabled &&
          selectedNodes[0]?.type !== 'Seed' &&
          selectedNodes[0]?.type !== ETreeNodeTypes.SynchrotronTripv4) ||
        isAnySelectedNodeLocked ||
        isQuickAccessNodeSelected,
      contentContainerClass: 'tree-control-action-button',
    },
    {
      Icon: (
        <RMSvgIcon name="Delete" width="20px" height="20px" fill={headerIconsColor} />
      ),
      titleTip: 'Delete',
      onClick: () => checkSystemBusy(deleteNode),
      isDisabled:
        !isEditAllowed ||
        !canModifyNode ||
        isControlsDisabled ||
        isAnySelectedNodeLocked ||
        isQuickAccessNodeSelected,
      contentContainerClass: 'tree-control-action-button',
    },
    {
      Icon: (
        <RMSvgIcon
          name="PrintBarcode"
          width="27px"
          height="27px"
          fill={headerIconsColor}
        />
      ),
      titleTip: 'Print Barcode',
      onClick: printBarcode,
      isDisabled: printBarcodeDisabled,
      contentContainerClass: 'tree-control-action-button',
    },
    {
      Icon: <RMSvgIcon name="HitsReport" fill="rgba(49, 49, 49, 1)" />,
      titleTip: 'Hits Report',
      onClick: onClickHitReportButton,
      isDisabled: hitsReportDisabled,
    },
    {
      iconProps: {
        name: doAllSelectedNodesExistInQuickAccess ? 'Unpin' : 'Pin',
        fill: doAllSelectedNodesExistInQuickAccess ? 'white' : 'rgba(49, 49, 49, 1)',
      },
      titleTip: doAllSelectedNodesExistInQuickAccess
        ? 'Unpin from Quick Access'
        : 'Pin to Quick Access',
      onClick: doAllSelectedNodesExistInQuickAccess
        ? unPinFromQuickAccess
        : pinToQuickAccess,
      isDisabled:
        rmLite ||
        isControlsDisabled ||
        selectedNodes?.length === 0 ||
        isAnySelectedNodeLocked ||
        !(
          doAllSelectedNodesExistInQuickAccess || doAllSelectedNodesNotExistInQuickAccess
        ) ||
        selectedNodes.some((node) => node.type === ETreeNodeTypes.FragmentScreen),
    },
    {
      multiLevelDropDown: (
        <RMDropdown
          icon={
            <RMSvgIcon
              name="ThreeDotMenu"
              width="20px"
              height="20px"
              fill={headerIconsColor}
            />
          }
          dropDownItems={ExtraOptions}
          isDisabled={
            (isControlsDisabled && isRootNodeAccessControl) || isQuickAccessNodeSelected
          }
          direction="rtl"
        />
      ),
      isMultilevelDropDown: true,
      contentContainerClass: 'tree-control-action-button',
    },
  ];

  /** Adding call back/useMemo to this method as it is used in explorer right click,
   if we dont memoize it, then it will cause infinite re-rendering
   due to new refernece each time. Handle with caution */
  const openSynchTripReport = useCallback(() => {
    const selectedNodeExtra = selectedNodes[0]?.extra;
    const tripId = selectedNodeExtra?.id;
    setModalStates(() => ({
      ...modalStates,
      showModal: true,
      showButtons: false,
      heading: 'Synchrotron Trip Report',
      body: (
        <SynchTripReportOptions
          synchTripId={tripId}
          closeReportOptionsModal={() =>
            setModalStates({ ...modalStates, showModal: false })
          }
        />
      ),
    }));
  }, [selectedNodes, selectedNodes[0]?.extra]);

  /** Adding call back/useMemo to this method as it is used in explorer right click,
   if we dont memoize it, then it will cause infinite re-rendering
   due to new refernece each time. Handle with caution */
  const onExportPOI = useCallback(async () => {
    selectedNodes.map(async (node) => {
      const selectedNodeExtra = node?.extra;
      const expId = selectedNodeExtra?.id;
      await exportPOI(expId, null, null, null, null, false);
    });
  }, [selectedNodes, selectedNodes[0]?.extra]);

  /** Adding call back/useMemo to this method as it is used in explorer right click,
   if we dont memoize it, then it will cause infinite re-rendering
   due to new refernece each time. Handle with caution */
  const onMarkAsNotSeen = useCallback(async () => {
    await markAskNotSeen(selectedNodes, setTreeControlState);
  }, [selectedNodes, setTreeControlState]);

  /** Adding call back/useMemo to this method as it is used in explorer right click,
   if we dont memoize it, then it will cause infinite re-rendering
   due to new refernece each time. Handle with caution */
  const exportToXmlFile = useCallback(async () => {
    selectedNodes.map(async (node) => {
      const expId = node?.extra?.id;
      const expName = node?.extra?.name;
      await ExportToXMLExperimentfromExpId(expId, expName);
    });
  }, [selectedNodes, selectedNodes[0]?.extra]);

  /** Adding call back/useMemo to this method as it is used in explorer right click,
   if we dont memoize it, then it will cause infinite re-rendering
   due to new refernece each time. Handle with caution */
  const exportToTextFile = useCallback(async () => {
    selectedNodes.map(async (node) => {
      const expId = node?.extra?.id;
      const expName = node?.extra?.name;
      await exportTextScreen(expName, [], expId);
    });
  }, [selectedNodes, selectedNodes[0]?.extra]);

  /** Adding call back/useMemo to this method as it is used in explorer right click,
   if we dont memoize it, then it will cause infinite re-rendering
   due to new refernece each time. Handle with caution */
  const onGenerateScreenStocksReport = useCallback(async () => {
    const expId = selectedNodes[0]?.extra?.id;
    await generateScreenStocksReport(expId);
    setModalStates({ ...modalStates, showModal: false });
  }, [selectedNodes, selectedNodes[0]?.extra]);

  /** Adding call back/useMemo to this method as it is used in explorer right click,
   if we dont memoize it, then it will cause infinite re-rendering
   due to new refernece each time. Handle with caution */
  const rotateCanvasUpdatedProperties = [];
  const onChangeRotateCanvasMessageBoxValue = useCallback(
    async (e: any, isChecked, setIsChecked) => {
      const prop: BooleanPropertyDTO = new BooleanPropertyDTO({
        displayName: 'Show Rotate Canvas MessageBox',
        name: 'Screen.RotateCanvas.ShowMessageBox',
        categoryName: 'Misc',
        value: isChecked,
      });

      if (prop instanceof BooleanPropertyDTO) {
        prop.value = isChecked;
      }

      const idx = rotateCanvasUpdatedProperties.findIndex((p) => p.name === prop.name);
      if (idx >= 0) {
        rotateCanvasUpdatedProperties[idx] = prop;
      } else {
        rotateCanvasUpdatedProperties.push(prop);
      }
      setIsChecked(!isChecked);
    },
    [],
  );

  /** Adding call back/useMemo to this method is used in experiment right click,
   if we dont memoize it, then it will cause infinite re-rendering
   due to new refernece each time. Handle with caution */
  const exportOptions = useMemo(
    () => [
      {
        label: 'Export POI',
        onClick: onExportPOI,
      },
      {
        label: 'Export To Text File',
        onClick: exportToTextFile,
        isDisabled: rmLite,
      },
      {
        label: 'Export To XML File',
        onClick: exportToXmlFile,
        isDisabled: rmLite,
      },
    ],
    [onExportPOI, exportToTextFile, exportToXmlFile, rmLite],
  );

  const isExplorerNode =
    treeControlState?.selectedNodes[0]?.id === treeControlState?.selectedExplorerNode?.id;
  const isContextBackground = !!treeControlState?.isContextBackground;

  const onChangeScheduleBulk = useCallback(() => {
    const experimentIds = selectedNodes
      .filter((node) => node.type === ETreeNodeTypes.Experiment)
      .map((node) => node.extra?.id)
      .filter((id) => id !== undefined && id !== null) as number[];

    if (experimentIds.length > 0) {
      showBulkScheduleModal({
        heading: 'Change Schedule',
        body: (
          <ImagingSchedule
            bulkMode={true}
            experimentIds={experimentIds}
            setRefresh={() => {}}
            onClose={hideBulkScheduleModal}
            onSaveReady={(saveHandler) => {
              bulkScheduleSaveHandlerRef.current = saveHandler;
            }}
          />
        ),
        showButtons: true,
        okButtonText: 'Confirm',
        noButtonText: 'Cancel',
        onOk: async () => {
          if (bulkScheduleSaveHandlerRef.current) {
            await bulkScheduleSaveHandlerRef.current();
            showAlertSnackBar(
              EAlertType.SUCCESS,
              ESnackBarPosition.TOP,
              'Imaging schedules saved successfully',
            );
          }
          hideBulkScheduleModal();
        },
        onCancel: hideBulkScheduleModal,
        size: FmlxModal.Size.MEDIUM,
      });
    }
  }, [selectedNodes, showBulkScheduleModal, hideBulkScheduleModal]);

  /** Only add methods which are memoized, otherwise it can cause infinite re-rendering.
      Deal with caution */
  const actionMap = useMemo(
    () => ({
      [ERightClickAction.Open]: {
        action: openNode,
        isDisabled:
          isAnySelectedNodeLocked ||
          treeControlState.selectedNodes.length !== 1 ||
          treeControlState.selectedNodes[0] === treeControlState.selectedExplorerNode,
      },
      [ERightClickAction.ExportPOI]: {
        action: onExportPOI,
      },
      [ERightClickAction.Analyze]: {
        action: () => {},
        subMenu: isExplorerNode
          ? AnalyzeOptions
          : AnalyzeOptions.filter(
              (x) => x.label != analyzeOptionCreateSearchAndFilterLabel,
            ),
      },
      [ERightClickAction.Export]: {
        action: () => {},
        subMenu: exportOptions,
      },
      [ERightClickAction.NewFolder]: {
        action: onNewFolder,
        isDisabled:
          rmLite ||
          treeControlState.selectedExplorerNode?.accessRightName !==
            ETreeNodeAccessRightNames.Modify,
      },
      [ERightClickAction.NewScreen]: {
        action: () => onAddItem(ETreeNodeTypes.Screen),
        isDisabled:
          rmLite ||
          treeControlState.selectedExplorerNode?.accessRightName !==
            ETreeNodeAccessRightNames.Modify ||
          (isAddNotAllowed &&
            treeControlState.selectedExplorerNode?.type !== ETreeNodeTypes.Screens &&
            treeControlState.selectedExplorerNode?.type !== ETreeNodeTypes.ScreensFolder),
      },
      [ERightClickAction.NewProject]: {
        action: () => {
          setCreateNodeType(ECreateNodeType.Project);
        },
        isDisabled: rmLite || canAddProject(treeControlState.selectedExplorerNode),
      },
      [ERightClickAction.NewExperiment]: {
        action: () => onAddItem(ETreeNodeTypes.Experiment),
        isDisabled:
          rmLite ||
          treeControlState.selectedExplorerNode?.accessRightName !==
            ETreeNodeAccessRightNames.Modify ||
          isAddNotAllowed ||
          isAddingNode,
      },
      [ERightClickAction.NewProteinFormulation]: {
        action: () => onAddItem(ETreeNodeTypes.Protein),
        isDisabled:
          rmLite ||
          treeControlState.selectedExplorerNode?.accessRightName !==
            ETreeNodeAccessRightNames.Modify ||
          isAddNotAllowed ||
          isAddingNode,
      },
      [ERightClickAction.NewFragmentScreen]: {
        action: () => {
          onAddItem(ETreeNodeTypes.FragmentScreen);
        },
        isDisabled:
          rmLite ||
          isAddNotAllowed ||
          treeControlState.selectedExplorerNode?.accessRightName !==
            ETreeNodeAccessRightNames.Modify ||
          isAddingNode,
      },
      [ERightClickAction.NewSynchrotronTrip]: {
        action: () => onAddItem(ETreeNodeTypes.CrystalTrackv4),
        isDisabled:
          (treeControlState.selectedExplorerNode?.type !==
            ETreeNodeTypes.CrystalTrackv4 &&
            treeControlState.selectedExplorerNode?.type !==
              ETreeNodeTypes.SynchrotronTripv4Folder) ||
          isAddingNode,
      },
      [ERightClickAction.NewSearchFolder]: {
        action: () => setCreateNodeType(ECreateNodeType.SearchesFolder),
        isDisabled:
          rmLite ||
          treeControlState.selectedExplorerNode?.accessRightName !==
            ETreeNodeAccessRightNames.Modify ||
          isAddingNode,
      },
      [ERightClickAction.NewSearchAndFilter]: {
        action: () => onAddItem(ETreeNodeTypes.SearchAnalysis),
        isDisabled:
          isNewSnfDisabled(
            treeControlState.selectedExplorerNode,
            isPlatePreviewEdition,
          ) || isAddingNode,
      },
      [ERightClickAction.Cut]: {
        action: cutNode,
        isDisabled: cutDisabled,
      },
      [ERightClickAction.Copy]: {
        action: copyNode,
        isDisabled: copyDisabled,
      },
      [ERightClickAction.Paste]: {
        action: pasteNode,
        isDisabled: pasteDisabled,
      },
      [ERightClickAction.Delete]: {
        action: deleteNode,
        isDisabled:
          !isEditAllowed ||
          !canModifyNode ||
          isControlsDisabled ||
          isAnySelectedNodeLocked ||
          isSystemBusy,
      },
      [ERightClickAction.Rename]: {
        action: () => {
          setShowRenameModal(true);
        },
        isDisabled:
          !isEditAllowed ||
          !canModifyNode ||
          selectedNodes.length !== 1 ||
          (isControlsDisabled &&
            selectedNodes[0]?.type !== 'Seed' &&
            selectedNodes[0]?.type !== ETreeNodeTypes.SynchrotronTripv4) ||
          isAnySelectedNodeLocked,
      },
      [ERightClickAction.SynchrotronTripReport]: {
        action: openSynchTripReport,
      },
      [ERightClickAction.ImageNow]: {
        action: openImageNowModal,
        isDisabled: isImageNowDisabled(rmLite, selectedNodes),
      },
      [ERightClickAction.MarkAsNotSeen]: {
        action: onMarkAsNotSeen,
        isDisabled:
          rmLite ||
          !selectedNodes.every((node) => node.type === 'Experiment') ||
          selectedNodes.some((node) => !!node.extra?.notSeen) ||
          selectedNodes.some((node) => node.extra?.plateState < EPlateState.Imaged),
      },
      [ERightClickAction.ExportToTextFile]: {
        action: exportToTextFile,
        isDisabled: rmLite,
      },
      [ERightClickAction.ExportToXmlFile]: {
        action: exportToXmlFile,
        isDisabled: rmLite,
      },
      [ERightClickAction.ExperimentReport]: {
        action: () => setReportType(EReportTypes.ExperimentReport),
        isDisabled: true,
      },
      [ERightClickAction.ScreenStocksReport]: {
        action: licenseAuthCommand(() => {
          setModalStates({
            ...modalStates,
            showModal: true,
            body: (
              <div id="tree-control-header-confirmation">
                Are you sure you want to generate Screen Stock Report?
              </div>
            ),
            heading: 'Confirmation',
            onOk: onGenerateScreenStocksReport,
          });
        }, EUserAction.ScreenStockReport),
      },
      [ERightClickAction.RotateCanvas]: {
        action: () =>
          rotateCanvas(
            selectedNodes,
            <RotateCanvasModal onChange={onChangeRotateCanvasMessageBoxValue} />,
            rotateCanvasUpdatedProperties,
            createNewNode,
          ),
        isDisabled: !selectedNodes.every((item) => item.type === 'Screen'),
      },
      [ERightClickAction.NewProteinVariant]: {
        action: () => setShowProteinVariantModal(true),
      },
      [ERightClickAction.PrintBarcode]: {
        action: () => printBarcode(),
        isDisabled: printBarcodeDisabled,
      },
      [ERightClickAction.HitsReport]: {
        action: () => onClickHitReportButton(),
        isDisabled: hitsReportDisabled,
      },
      [ERightClickAction.ChangeSchedule]: {
        action: onChangeScheduleBulk,
        isDisabled: false,
      },
      [ERightClickAction.SendToAutoScore]: {
        action: bulkSendToAutoScore,
        isDisabled:
          rmLite ||
          isAnySelectedNodeLocked ||
          !isMarcoScoringEnabled ||
          !isRootNodeAccessControl,
      },
    }),
    [
      onNewFolder,
      AnalyzeOptions,
      exportOptions,
      cutNode,
      copyNode,
      pasteNode,
      deleteNode,
      onAddItem,
      openNode,
      setShowRenameModal,
      setCreateNodeType,
      onExportPOI,
      onMarkAsNotSeen,
      openImageNowModal,
      exportToTextFile,
      exportToXmlFile,
      licenseAuthCommand,
      onGenerateScreenStocksReport,
      onChangeRotateCanvasMessageBoxValue,
      setShowProteinVariantModal,
      isAddingNode,
      printBarcode,
      onClickHitReportButton,
      bulkSendToAutoScore,
      onChangeScheduleBulk,
    ],
  );

  useEffect(() => {
    if (treeControlState.selectedNodes.length > 1) {
      if (
        treeControlState.selectedNodes.every(
          (node) => node.type === ETreeNodeTypes.Experiment,
        )
      ) {
        setMultiNodesRightClick(
          actionMap,
          EMultiSelectionTypes.Experiment,
          true,
          !!isBarcodeProperty,
        );
      } else {
        const isAnalyzeAllowed = isAnalyzeAllowedMultiSelect(
          treeControlState.selectedNodes,
        );
        setMultiNodesRightClick(
          actionMap,
          EMultiSelectionTypes.Files,
          isAnalyzeAllowed,
          !!isBarcodeProperty,
        );
      }
    }

    if (treeControlState.selectedNodes.length == 1) {
      if (isExplorerNode) {
        setNodeRightClick(
          actionMap,
          treeControlState.selectedExplorerNode?.type,
          true,
          isContextBackground,
          !!isBarcodeProperty,
        );
      } else {
        setNodeRightClick(
          actionMap,
          treeControlState.selectedNodes[0].type,
          false,
          isContextBackground,
          !!isBarcodeProperty,
        );
      }
    }

    return () => {
      setNodeRightClick(null, null);
      setMultiNodesRightClick(null, null);
    };
  }, [
    actionMap,
    treeControlState.selectedExplorerNode?.type,
    treeControlState.selectedNodes,
    isContextBackground,
    isBarcodeProperty,
  ]);

  if (!rmLite) {
    headerButtons.splice(1, 0, {
      Icon: <RMSvgIcon name="Add" width="20px" height="20px" fill={'#0059CC'} />,
      title: 'NEW',
      color: '#0059CC',
      isDisabled:
        !isEditAllowed ||
        treeControlState.selectedExplorerNode?.locked ||
        treeControlState.selectedExplorerNode?.type === ETreeNodeTypes.QuickAccess ||
        treeControlState.selectedNodes.length !== 1,
      dropDownList: AddList.filter(
        (content) =>
          content.label !== 'Project' ||
          (treeControlState.selectedExplorerNode?.type !== ETreeNodeTypes.Screens &&
            treeControlState.selectedExplorerNode?.type !== ETreeNodeTypes.ScreensFolder),
      ),
      showChevronIcon: true,
      showBorder: true,
      contentContainerClass: 'tree-control-bordered-action-button',
    });
  }

  const hideModal = (showModal) => {
    setModalStates({ ...modalStates, showModal });
  };

  function isRootNodeAccessControlEnabled() {
    return !selectedNodes.some((node) => AllowedRootNodes.includes(node.type));
  }

  function isBarcodeDisabled() {
    return !selectedNodes.every((node) =>
      AllowedTypesForBarcodeOperation.includes(node.type),
    );
  }

  function isHitReportDisabled() {
    return !selectedNodes.some((node) =>
      AllowedTypesForHitReportOperation.includes(node.type),
    );
  }

  async function newNode(newNode, parentTreeNodeId) {
    await createNewNode(newNode, [], parentTreeNodeId);
  }

  const renderHeaderButtons = useMemo(
    () =>
      headerButtons.map((item, index) => {
        if (item.isMultilevelDropDown) {
          return item.multiLevelDropDown;
        } else {
          return <RMCustomButton key={'tree-header-action-button' + index} {...item} />;
        }
      }),
    [headerButtons],
  );
  return (
    <>
      <div
        id="tree-control-header-main-container"
        className="tree-control-header-main-container"
      >
        <TreeNodeCreator
          type={createNodeType}
          setType={setCreateNodeType}
          parentTreeNodeId={treeControlState.selectedExplorerNode?.id}
          newNode={newNode}
          newFolderType={newFolderType}
        />

        <RenameComponent
          showModal={showRenameModal}
          setShowModal={setShowRenameModal}
          treeNodeId={selectedNodes[0]?.id}
          treeNodeName={selectedNodes[0]?.name}
          refreshTreeNodeAfterRename={refreshTreeNodeAfterRename}
        ></RenameComponent>

        <RMModal
          {...modalStates}
          setShowModal={hideModal}
          size={modalStates.size || FmlxModal.Size.LARGE}
        />

        <HitsReportOptionsDialogue
          /**
           * Temporary Workaround to keep things working after multiselect in treeNode
           * need to update the hit reports to support multiple nodes
           */
          nodeIds={selectedNodes.map((item) => item.id)}
          show={showHitReportOptions}
          setShow={setShowHitReportOptions}
          showNoHitError={showNoHitError}
          setShowNoHitError={setShowNoHitError}
          maxNumOfDrops={maxHitsReportDropNumber}
        />
        <div
          id="tree-control-header-control-bread-crumb-container"
          className="tree-control-bread-crumb-container"
        >
          <CustomBreadCrumbs
            isProteinControl={isProteinControl}
            isScreenControl={isScreenControl}
            treeNodes={treenodes}
            breadCrumbs={crumbs}
            onBreadCrumbClick={OnBreadCrumbClickSelect}
          />
        </div>
        <div
          id="tree-control-header-control-action-container"
          className={`tree-control-action-container ${
            rmLite ? 'justify-end mr-[2%]' : ''
          }`}
        >
          {!rmLite ? (
            renderHeaderButtons
          ) : (
            <RMCustomButton key={'tree-header-action-button-0'} {...headerButtons[0]} />
          )}
        </div>
      </div>
      {reportType !== '' && (
        <ExperimentReportDialogueWrapper
          reportType={reportType}
          setReportType={setReportType}
          expId={selectedNodes[0]?.extra?.id}
        />
      )}
      <RMModal
        setShowModal={setShowModal}
        showModal={showModal}
        body={modalDetails.content}
        heading={modalDetails.heading}
        isOkOnly={modalDetails.isOkOnly}
        showButtons={modalDetails.showButtons}
        okButtonText={modalDetails.okButtonText}
        noButtonText={modalDetails.noButtonText}
        dialogClassName={modalDetails.dialogClassName}
        titleClr={modalDetails.titleClr}
        onHide={modalDetails.onHide}
        size={modalDetails.size}
      />
    </>
  );
}

export default memo(TreeControlHeader);
